import { makeApolloClient, logError } from '../util';
import { PINNED_ANNOUNCEMENTS, PINNED_POSTS } from 'queries/pinned';
import { SET_PINNED_ANNOUNCEMENTS, SET_PINNED_POSTS } from './actionTypes';

export const setPinnedAnnouncements = (announcements, from) => ({
	type: SET_PINNED_ANNOUNCEMENTS,
	announcements,
	from,
});

export const setPinnedPosts = (posts, from) => ({
	type: SET_PINNED_POSTS,
	posts,
	from,
});

export const thunkFetchPinnedAnnouncements = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { pinnedAnnouncements } = await client.request(PINNED_ANNOUNCEMENTS, {
			event_id: eventID,
		});
		dispatch(setPinnedAnnouncements(pinnedAnnouncements, from));
	} catch (error) {
		logError(error, 'pinned.actions.thunkFetchPinnedAnnouncements');
	}
};

export const thunkFetchPinnedPosts = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { pinnedPosts } = await client.request(PINNED_POSTS, {
			event_id: eventID,
		});
		const posts = pinnedPosts.nodes;
		dispatch(setPinnedPosts(posts, from));
		return posts;
	} catch (error) {
		logError(error, 'pinned.actions.thunkFetchPinnedPosts');
	}
};
